import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "d-flex justify-content-center",
    style: { "min-height": "400px" }
};
const _hoisted_2 = { class: "text-center mt-3" };
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 0,
    class: "mt-5 small"
};
import { onMounted, ref } from 'vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import { cssStyleSheetLoader } from '../Composables/cssStyleSheetLoader';
import ConfiguratorLayout from '../Layouts/ConfiguratorLayout.vue';
import { usePage } from '@inertiajs/vue3';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import CustomerLoginAndRegistrationForm from '@/Shared/CustomerLoginAndRegistrationForm.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerLogin',
    props: {
        tenantId: String,
        componentUuid: String,
        cssFileUrl: {
            type: String,
            default: null
        },
        sessionId: {
            type: String,
            required: true
        },
        countries: {
            type: Array,
            required: true
        },
        languages: {
            type: Array,
            required: true
        },
        status: String
    },
    setup(__props) {
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        const props = __props;
        const user = ref(usePage().props.auth.user);
        const imprintUrl = ref('');
        const privacyUrl = ref('');
        const tocUrl = ref('');
        const cancellationRightUrl = ref('');
        onMounted(async () => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            //load configs
            imprintUrl.value = await loadTenantConfigs('imprint_url');
            privacyUrl.value = await loadTenantConfigs('privacy_url');
            tocUrl.value = await loadTenantConfigs('toc_url');
            cancellationRightUrl.value = await loadTenantConfigs('cancellation_right_url');
            sendHeight();
            observeDOMChanges();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                            _createVNode(CustomerLoginAndRegistrationForm, {
                                status: props.status,
                                tenantId: props.tenantId,
                                countries: props.countries,
                                languages: props.languages
                            }, null, 8, ["status", "tenantId", "countries", "languages"]),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("a", {
                                    href: imprintUrl.value,
                                    target: "_blank"
                                }, "Impressum", 8, _hoisted_3),
                                _cache[0] || (_cache[0] = _createTextVNode(" | ", -1)),
                                _createElementVNode("a", {
                                    href: privacyUrl.value,
                                    target: "_blank"
                                }, "Datenschutzerklärung", 8, _hoisted_4),
                                _cache[1] || (_cache[1] = _createTextVNode(" | ", -1)),
                                _createElementVNode("a", {
                                    href: tocUrl.value,
                                    target: "_blank"
                                }, "Nutzungsbedingungen", 8, _hoisted_5)
                            ]),
                            (user.value && !user.value.isCustomer)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(props.sessionId), 1))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
